module.exports = __webpack_public_path__ + "img/cpu.c6458b1c.svg";